import type { Reducer } from 'redux';

import type { DeferredFeedsClearAction } from '../../domains/deferredFeeds/actions.types';
import type { FeedLoadDeferredFulfillAction } from '../../domains/feedLoad/actions.types';
import type { PublishGroupMessageFulfilledAction } from '../../domains/publishers/actions.types';
import type { FeedThreadUpdateTimeInfo } from '../types';

import type { DeferredFeeds } from './types';

export type DeferredFeedsAction =
  | FeedLoadDeferredFulfillAction
  | DeferredFeedsClearAction
  | PublishGroupMessageFulfilledAction;

const initialState: DeferredFeeds = {
  current: undefined,
  latest: undefined,
  cacheKey: undefined,
  isStale: false,
  shouldRemoveCache: false,
};

const reducer: Reducer<DeferredFeeds, DeferredFeedsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_DEFERRED_FULFILL':
      return {
        current: {
          id: action.payload.id,
          lastMessageId: action.payload.currentFeedLastMessageInfo?.lastMessageId,
          lastMessageAt: action.payload.currentFeedLastMessageInfo?.lastMessageAt,
          topThreadsIds: action.payload.currentFeedThreadsUpdateTimes
            ? action.payload.currentFeedThreadsUpdateTimes.map((update: FeedThreadUpdateTimeInfo) => update.threadId)
            : undefined,
          topThreadsUpdateTimes: action.payload.currentFeedThreadsUpdateTimes
            ? action.payload.currentFeedThreadsUpdateTimes.map((update: FeedThreadUpdateTimeInfo) => update.updatedAt)
            : undefined,
        },
        latest: {
          id: action.payload.id,
          lastMessageId: action.payload.latestFeedLastMessageInfo?.lastMessageId,
          lastMessageAt: action.payload.latestFeedLastMessageInfo?.lastMessageAt,
          topThreadsIds: action.payload.latestFeedThreadsUpdateTimes
            ? action.payload.latestFeedThreadsUpdateTimes.map((update) => update.threadId)
            : undefined,
          topThreadsUpdateTimes: action.payload.latestFeedThreadsUpdateTimes
            ? action.payload.latestFeedThreadsUpdateTimes.map((update) => update.updatedAt)
            : undefined,
        },
        cacheKey: action.payload.cacheKey,
        isStale: false,
        shouldRemoveCache: false,
      };
    case 'DEFERRED_FEEDS.CLEAR':
      return {
        ...state,
        isStale: true,
      };
    case 'PUBLISHER.PUBLISH_GROUP_MESSAGE_FULFILLED':
      return {
        ...state,
        shouldRemoveCache: true,
      };
    default:
      return state;
  }
};

export default reducer;
